import { AnnouncementsFromBackend } from 'app/api/services/live/schedule/types';

import type { tFunction } from 'app/lang';
import { SportId } from 'app/lib/betting/constants';

import dictionary from './Announcement.dictionary.json';

// ---

type TournamentId = number;

export type AnnouncementsByTournamentId = Map<TournamentId, AnnouncementsFromBackend>;

export type AnnouncementsContent = { data: AnnouncementsByTournamentId; sportName: string };

export type AnnouncementsBySportId = Map<SportId, AnnouncementsContent>;

export const enum TimeFilterValue {
  ALL_TIME = 0,
  ONE_HOURS = 1,
  TWO_HOURS = 2,
  SIX_HOURS = 6,
  TWELVE_HOURS = 12,
  FULL_DAY = 24,
}

export type TimeOption = {
  value: TimeFilterValue;
  label: string;
};

export const getTimeFilterOptions = (t:tFunction) => {
  return [
    {
      value: TimeFilterValue.ALL_TIME,
      label: t(dictionary.allTime),
    },
    {
      value: TimeFilterValue.ONE_HOURS,
      label: t(dictionary.hours, { count: TimeFilterValue.ONE_HOURS }),
    },
    {
      value: TimeFilterValue.TWO_HOURS,
      label: t(dictionary.hours, { count: TimeFilterValue.TWO_HOURS }),
    },
    {
      value: TimeFilterValue.SIX_HOURS,
      label: t(dictionary.hours, { count: TimeFilterValue.SIX_HOURS }),
    },
    {
      value: TimeFilterValue.TWELVE_HOURS,
      label: t(dictionary.hours, { count: TimeFilterValue.TWELVE_HOURS }),
    },
    {
      value: TimeFilterValue.FULL_DAY,
      label: t(dictionary.hours, { count: TimeFilterValue.FULL_DAY }),
    },
  ];
};

export type SportOption = {
  value: SportId;
  label: string;
};
